<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['order.no']" :placeholder="$t('placeholder.outboundOrderNo')" allowClear @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['wave']" :placeholder="$t('placeholder.wave')" allowClear @pressEnter="getData" @search="getData"/>
      <a-select v-model="query['storer.id']" :placeholder="$t('placeholder.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <a-input-search v-model="query['customer.name']" :placeholder="$t('placeholder.customerName')" allowClear @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['item.name']" :placeholder="$t('placeholder.itemName')" allowClear @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['item.barcodes']" :placeholder="$t('placeholder.itemBarcode')" allowClear @pressEnter="getData" @search="getData"/>
      <a-date-picker v-model="query.invoiceTimeFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" allowClear show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.invoiceTimeFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" allowClear show-today valueFormat="YYYY-MM-DD"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="getData"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exportExcel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      size="mini"
      :height="scrollY"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
      <vxe-column field="dispatch.wave" sortable title="business.label.wave" width="100"/>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
      <vxe-column field="order.orderStatus" sortable title="business.label.orderStatus" width="120">
        <span slot-scope="{ row }">{{orderStatusData.find(item => item.ordinal === row.order.orderStatus).name}}</span>
      </vxe-column>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="customer.name" title="business.label.customerName" width="150"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" sortable title="business.label.lotNo" width="100"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="location.no" title="business.label.locationNo" width="100"/>
      <vxe-column field="container.no" title="business.label.containerNo" width="100"/>
      <vxe-column field="detail.plannedQuantity" title="business.label.plannedQuantity" width="80"/>
      <vxe-column field="detail.actualQuantity" title="business.label.actualQuantity" width="80"/>
      <vxe-column field="detail.lessnessQuantity" title="business.label.lessnessQuantity" width="80"/>
      <vxe-column field="detail.unallocatedQuantity" title="business.label.unallocatedQuantity" width="80"/>
      <vxe-column field="detail.packType" title="business.label.packType" width="80">
        <span slot-scope="{ row }">{{packTypes.find(item => item.ordinal === row.detail.packType).name}}</span>
      </vxe-column>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="detail.original" title="business.label.original" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ShipmentDetailQuery',
  data() {
    return {
      data: [],
      orderStatusData: [],
      storerData: [],
      packTypes: [],
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'order.no': '',
        wave: '',
        'customer.name': '',
        'storer.id': undefined,
        invoiceTimeFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'item.no': '',
        'item.name': '',
        'item.barcodes': '',
        'refundable': false
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条,减去的数值是页面其他元素的高度
    }
  },
  mounted() {
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storerData = res.result
      }
    })
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatusData = res.result
      }
    })
    findEnum('PackType').then(res => {
      if (res.success) {
        this.packTypes = res.result
      }
    })
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.invoiceTimeFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.invoiceTimeFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.invoiceTimeFilter.start === null && args.invoiceTimeFilter.end === null) {
        args.invoiceTimeFilter = null
      }
      findAll('shipmentDetailFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          setTimeout(() => {
            this.loading = false
          }, 300)
        } else {
          this.loading = false
        }
      })
    },
    exportExcel() {
      this.$refs.table.openExport()
    },
    reset() {
      this.query = {
        'order.no': '',
        'customer.name': '',
        'storer.id': undefined,
        invoiceTimeFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'item.no': '',
        'item.name': '',
        'wave': '',
        'item.barcodes': '',
        'refundable': false
      }
      this.getData()
    }
  }
}
</script>
<style scoped>
.query {
  width: 180px;
}
</style>